import * as React from 'react';

import { enumCustomAttributeEntityType } from '@rematter/frontend-lib-api-client';
import { TextField } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';

import * as facilityFormLocalState from '../../_state/facilityForm.localState';

import { AddressSection } from './AddressSection';

import { useTranslations } from '@/facilities/i18n/useTranslations';
import { CustomAttributeFieldsSection } from '~/shared/components/custom-attributes/CustomAttributesSection';

interface FacilityFormProps {
  isEditing?: boolean;
}

export const FacilityForm = (_props: FacilityFormProps) => {
  const t = useTranslations();
  const form = useAtomValue(facilityFormLocalState.$facilityForm);
  const updateForm = useSetAtom(facilityFormLocalState.$updateFacilityForm);

  const handleFieldChange =
    <K extends keyof typeof form>(field: K) =>
    (value: (typeof form)[K]) => {
      updateForm({
        [field]: value,
      });
    };

  const customAttributesValues = React.useMemo(
    () => form.customAttributes ?? {},
    [form.customAttributes],
  );

  return (
    <div className="@FacilityForm space-y-4">
      <TextField
        label={t.facilities.form.fields.name.label}
        placeholder={t.facilities.form.fields.name.placeholder}
        value={form.facilityName}
        onChange={handleFieldChange('facilityName')}
        isRequired
      />

      <TextField
        label={t.facilities.form.fields.type.label}
        placeholder={t.facilities.form.fields.type.placeholder}
        value={form.facilityType}
        onChange={handleFieldChange('facilityType')}
        isRequired
      />

      <CustomAttributeFieldsSection
        entityType={enumCustomAttributeEntityType.CoreFacility}
        columns={2}
        values={customAttributesValues}
        onChange={(v) => handleFieldChange('customAttributes')(v as never)}
      />

      <AddressSection form={form} onFieldChange={handleFieldChange} />
    </div>
  );
};
